"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadLuckEffectHandler = exports.BadLuckEffectArgs = void 0;
const Duration_1 = require("../../Duration");
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const MaxAttributeDecrease_1 = require("./MaxAttributeDecrease");
class BadLuckEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.BadLuck;
        this.__typeName = "BadLuck";
        this.name = "BadLuck";
        this.harmful = true;
    }
}
exports.BadLuckEffectArgs = BadLuckEffectArgs;
BadLuckEffectArgs.CustomText = "-5% crit chance.";
let BadLuckEffectHandler = class BadLuckEffectHandler {
    apply(sequence, container, state) {
        state.meta.critDecrease = container.applyDebuff({
            sequence,
            attackerId: state.creatorId,
            targetId: state.targetId,
            duration: Duration_1.Duration.Permanent,
            effect: new MaxAttributeDecrease_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.CriticalStrikeChance, 5),
            hidden: true,
            supernatural: true
        });
    }
    remove(sequence, container, state) {
        container.cancelEffect(sequence, state.meta.critDecrease);
    }
};
BadLuckEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.BadLuck)
], BadLuckEffectHandler);
exports.BadLuckEffectHandler = BadLuckEffectHandler;
